import { Link } from "react-router-dom";

type SectionTitleProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  align?: "left" | "center";
};

export default function SectionTitle({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
  align = "left",
}: SectionTitleProps) {
  const centered = align === "center";

  return (
    <div
      className={`flex flex-col gap-4 ${
        centered ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={centered ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            <span className="inline-block h-px w-6 bg-primary-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">{title}</h2>
        {description && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>}
      </div>

      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}